export default {
  success: 'Le fichier a été généré avec succès.',
  error: 'Une erreur est survenue lors de la génération du fichier.'
}
